import DashboardView from './DashboardView.vue'

export default DashboardView;
